// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-input .input-container {
  text-align: center;
}

.page-input .input-wrapper {
  display: inline-block;
  padding: 0 10px;
}

.page-input .input-container input::-webkit-outer-spin-button,
.page-input .input-container input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.page-input .input-container input {
  text-align: center;
  outline: none;
  background: none;
  font-size: 52px;
  font-weight: 700;
  line-height: 130%;
  width: 96px;
  border-bottom: 2px solid var(--input-border-color);
}

.page-input .input-container input[type='number'] {
  -moz-appearance: textfield;
}

.page-input .input-wrapper .unit {
  font-size: 24px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/base.input.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".page-input .input-container {\n  text-align: center;\n}\n\n.page-input .input-wrapper {\n  display: inline-block;\n  padding: 0 10px;\n}\n\n.page-input .input-container input::-webkit-outer-spin-button,\n.page-input .input-container input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.page-input .input-container input {\n  text-align: center;\n  outline: none;\n  background: none;\n  font-size: 52px;\n  font-weight: 700;\n  line-height: 130%;\n  width: 96px;\n  border-bottom: 2px solid var(--input-border-color);\n}\n\n.page-input .input-container input[type='number'] {\n  -moz-appearance: textfield;\n}\n\n.page-input .input-wrapper .unit {\n  font-size: 24px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
